module.exports = __webpack_public_path__ + "kn.svg?654d3a6d70b7d12d2b93f46d91564ee1";